export enum EMergeTagMenuState {
  Root,
  AddRecipient,
  Recipient,
  Sender,
  Entity,
  Document,
  Custom,
}
